import { UserContext } from "context";
import { useContext, useEffect } from "react";
import { useSelector } from "react-redux";
import { Navigate, useNavigate } from "react-router-dom";
import { StorageServices } from "utils";


const PublicRoute = ({ element }) => {
  const navigate = useNavigate();

  const {token ,userType} = useContext(UserContext)
 
  let isAuthenticated = token

  useEffect(() => {
    if (!isAuthenticated) {
      navigate("/");
    }

  }, [navigate, isAuthenticated])

  return !isAuthenticated ? element : <Navigate to={userType === 3?"/booking/room":userType === 4?"store/buyer":"/dashboard"} />;
};

export default PublicRoute
